<template>
  <validation-observer ref="observer" v-slot="{ invalid }">
    <interview-header :pageType=pageType />

    <div class="page-view">
      <b-container class="p-0">
        <interview-route-change-modal
        :show-route-change-modal="layout.showRouteChangeModal"
        @leavePage="routerNext()"
        @stayPage="layout.showRouteChangeModal = false"
        />
        <interview-type-information
            v-if="tabIndex === -1 && pageType === 'interview'"
            :interview="interview"
            :tab-index.sync="tabIndex"
            :typeLoading="typeLoading"
            @createToclist="createToclist"
          />
        <b-row class="p-0 m-0" v-if="tabIndex !== -1">
          <b-col xs="12" sm="12" md="12" lg="12" xl="12" class="p-0">
            <interview-toc-menu
              :toc-list="layout.tocList"
              :in-coming-index="tabIndex"
              :invalid="invalid"
              :interview="interview"
              @stepperItem="clickedStepperItem"
            />
          </b-col>

          <b-col
            v-show="!loadingStack['detail']"
            xs="12"
            sm="12"
            md="12"
            lg="12"
            xl="12"
            class="p-0"
          >
            <transition-group name="slide" mode="out-in">
              <div v-show="!loadingStack['detail']" key="main">
                <component
                  :is="currentComponent"
                  :interview="interview"
                  :fetch="fetch"
                  :tempBankQuestion.sync="tempBankQuestion"
                  :bankQuestion="bankQuestion"
                  :tempBankQuestionAI="tempBankQuestionAI"
                  :bankQuestionAI="bankQuestionAI"
                  :deletedQuestionAI="deletedQuestionAI"
                  :tempBankQuestionAts="tempBankQuestionAts"
                  :bankQuestionAts="bankQuestionAts"
                  @inputUpdate="updateInput"
                  @addNewQuestion="createNewQuestion"
                  @deleteQuestion="onDeleteQuestion"
                  @check-action="checkAction($event)"
                />
              </div>
            </transition-group>
            <div class="interview-action-bar">
              <interview-action-bar
                :tab-index.sync="tabIndex"
                :invalid="invalid"
                :loading-stack="loadingStack"
                :interviewType="interview.type"
                @check-action="checkAction($event)"
              />
            </div>
          </b-col>
          <b-col
            v-show="loadingStack['detail']"
            xs="12"
            sm="12"
            md="9"
            lg="9"
            xl="9"
            class="p-0"
          >
            <job-content-loading />
          </b-col>
        </b-row>
      </b-container>
    </div>
  </validation-observer>
</template>

<script>
import HrVenueService from '@/services/hrvenue.service';
import tocList from '@/components/hrVenue/interviewCreateEdit/mixins/tocList';
import { showNotification } from '@/static/helpers';
import interviewGeneralInformation from './interviewCreateEdit/interviewGeneralInformation.vue';
import interviewDetailInformation from './interviewCreateEdit/interviewDetailInformation.vue';
import interviewTypeInformation from './interviewCreateEdit/interviewTypeInformation.vue';
import interviewEvaluationCriteria from './interviewCreateEdit/interviewEvaluationCriteria.vue';
import ResourceManager from '../../services/resource.service';
import InterviewJobDetailsInformation from './interviewCreateEdit/interviewJobDetailsInformation.vue';

export default {
  name: 'InterviewCreateEdit',

  components: {
    InterviewTocMenu: () => import('./interviewCreateEdit/interviewTOCMenu.vue'),
    InterviewHeader: () => import('./interviewCreateEdit/interviewHeader.vue'),
    InterviewActionBar: () => import('./interviewCreateEdit/interviewActionBar.vue'),
    JobContentLoading: () => import('../job/jobAddEdit/JobContentLoading.vue'),
    InterviewRouteChangeModal: () => import('./interviewCreateEdit/interviewRouteChangeModal.vue'),
    interviewTypeInformation,
  },

  mixins: [tocList],
  data() {
    return {
      tempBankQuestion: [],
      bankQuestion: {
        questions: [],
      },
      tempBankQuestionAI: [],
      bankQuestionAI: {
        questions: [],
      },
      deletedQuestionAI: [],
      tempBankQuestionAts: [],
      bankQuestionAts: {
        questions: [],
      },
      tabIndex: -1,
      loadingStack: {},
      routerNext: null,
      layout: {
        showRouteChangeModal: false,
        isSubmit: false,
        tocList: [],
      },
      interview: {
        name: '',
        type: '',
        addedQuestionList: [],
        selectedConnection: null,
        selectedJob: null,
        jobDescription: '',
        selectedLanguages: [],
        selectedCriteria: [],
        criterias: [],
        isCheckedLanguageCheckBox: false,
        isCheckedLanguageDropdownError: false,
        tempPositionId: -1,
        tempJobDescription: '',
      },
      oldInterview: {},
      questionList: [],
      fetch: true,
      errorSelectbox: [],
      errorTitle: [],
      pageType: '',
      languageList: [
        {
          id: 2, key: 'en', code: 'en-US', title: 'English (UK)',
        },
        {
          id: 1, key: 'tr', code: 'tr-TR', title: 'Türkçe (TR)',
        },
        {
          id: 69, key: 'es', code: 'es-ES', title: 'Español (ES)',
        },
        {
          id: 25, key: 'fr', code: 'fr-FR', title: 'Français (FR)',
        },
        {
          id: 27, key: 'de', code: 'de-DE', title: 'Deutsch (DE)',
        },
      ],
      typeLoading: true,
    };
  },
  mounted() {

  },
  async created() {
    this.pageType = this.$route.path.includes('/question-generator') ? 'question' : 'interview';
    const { interviewId, step } = this.$route.params;
    if (step) {
      this.tabIndex = step;
    }
    this.typeLoading = true;
    if (interviewId) {
      this.loadingStack.detail = true;

      const {
        authorizedUsers,
        visibilityType,
        changeVisibilityTypeAuthorized,
        interview,
        languageId,
        questionLanguageId,
      } = await HrVenueService.getInterview(interviewId);
      if (interview !== null) {
        let position = null;
        if (interview.positionId) {
          position = await HrVenueService.getPositionWithId(interview.positionId);
        }
        const comQuestion = interview.interviewQuestions.map((quest) => { quest.id = Math.random().toString(16).slice(2); quest.positionId = interview.positionId; return quest; });
        const selectedOptions = authorizedUsers?.map(
          // eslint-disable-next-line prefer-template
          (item) => ({ displayName: item.name + ' ' + item.surname, value: item.id }),
        );
        this.interview = {
          ...interview,
          type: interview.type || 1,
          questions: [...comQuestion],
          addedQuestionList: [],
          visibilityType,
          changeVisibilityTypeAuthorized,
          authorizedUsers: selectedOptions || [],
          emailLanguage: this.languageList.find(
            (item) => item.id === languageId,
          ) || null,
          questionLanguage: this.languageList.find(
            (item) => item.id === questionLanguageId,
          ) || null,
          selectedLanguages: [],
          selectedCriteria: [],
          criterias: [],
          isCheckedLanguageCheckBox: false,
          isCheckedLanguageDropdownError: false,
          tempPositionId: position?.value?.id || -1,
          position: position || null,
          tempJobDescription: '',
          jobDescription: interview.jobDescription || '',
        };
        this.loadingStack.detail = false;
      }
    } else {
      this.interview = {
        ...this.interview,
        name: '',
        questions: [{
          title: '', id: Math.random().toString(16).slice(2), thinkTime: null, timeLimit: null,
        }],
        addedQuestionList: [],
      };
    }
    this.createToclist();
    this.typeLoading = false;
    this.oldInterview = JSON.parse(JSON.stringify(this.interview));
    this.oldQuestions = JSON.parse(JSON.stringify(this.interview.questions));
    if (this.interview.visibilityType === 0) {
      this.interview.visibilityType = 1;
    }
  },
  async beforeRouteLeave(to, from, next) {
    if (!this.layout.isSubmit) {
      const currentLanguage = this.languageList.find(
        (item) => item.code === ResourceManager.CurrentLang,
      );
      this.oldInterview = {
        jobDescription: this.oldInterview.jobDescription || '',
        questionLanguage: this.oldInterview.questionLanguage || currentLanguage,
        emailLanguage: this.oldInterview.emailLanguage || currentLanguage,
        ...this.oldInterview,
      };
      this.interview = {
        jobDescription: this.interview.jobDescription || '',
        questionLanguage: this.interview.questionLanguage || currentLanguage,
        emailLanguage: this.interview.emailLanguage || currentLanguage,
        ...this.interview,
      };
      const equal = JSON.stringify(this.oldInterview) === JSON.stringify(this.interview);
      if (equal) {
        next();
      } else {
        this.layout.showRouteChangeModal = true;
        this.routerNext = next;
        next(false);
      }
    } else {
      next();
    }
  },

  computed: {
    isQuestionPage() {
      return this.pageType === 'question';
    },
    currentComponent() {
      if (this.interview.type === 1) {
        if (this.tabIndex === 0) {
          return interviewGeneralInformation;
        } if (this.tabIndex === 1) {
          return InterviewJobDetailsInformation;
        } if (this.tabIndex === 2) {
          return interviewEvaluationCriteria;
        } if (this.tabIndex === 3) {
          return interviewDetailInformation;
        }
        return '';
      }
      if (this.tabIndex === 0) {
        return interviewGeneralInformation;
      } if (this.tabIndex === 1) {
        return InterviewJobDetailsInformation;
      } if (this.tabIndex === 2) {
        return interviewDetailInformation;
      }
      return '';
    },
  },

  methods: {
    createToclist() {
      this.layout.tocList = [];
      if (this.pageType !== 'question') {
        if (this.interview.type === 1) {
          this.layout.tocList = [
            {
              title: this.resource['hrvenue.menuInterviewGeneral'],
              key: 'interview-general',
              class: 'active',
            },
            {
              title: this.resource['hrvenue.menuInterviewJobDetails'],
              key: 'job-details',
              class: '',
            },
            {
              title: this.resource['hrvenue.menuCriteria'],
              key: 'evaluation-criteria',
              class: '',
            },
            {
              title: this.resource['hrvenue.menuQuestions'],
              key: 'preparingQuestions',
              class: '',
            },
          ];
        } else {
          this.layout.tocList = [
            {
              title: this.resource['hrvenue.menuInterviewGeneral'],
              key: 'interview-general',
              class: 'active',
            },
            {
              title: this.resource['hrvenue.menuInterviewJobDetails'],
              key: 'job-details',
              class: '',
            },
            {
              title: this.resource['hrvenue.menuQuestions'],
              key: 'preparingQuestions',
              class: '',
            },
          ];
        }
      } else {
        this.tabIndex = 0;
        this.layout.tocList = [
          {
            title: this.resource['hrvenue.menuInterviewGeneral'],
            key: 'interviewInfo',
            class: 'active',
          },
          {
            title: this.resource['hrvenue.menuInterviewJobDetails'],
            key: 'job-details',
            class: '',
          },
          {
            title: this.resource['hrvenue.menuQuestions'],
            key: 'preparingQuestions',
            class: '',
          },
        ];
      }
    },
    async checkAction(actionType) {
      if (actionType === 'continue') {
        await this.$refs.observer.validate();
        if ((this.isQuestionPage && this.tabIndex === 2 && this.interview.type === 3) || (!this.isQuestionPage && this.tabIndex === 3 && this.interview.type === 1)) {
          await this.$refs.observer.validate();
          const validationMessage = this.validateQuestions();
          if (validationMessage) {
            showNotification(
              this.resource['label.Error'],
              validationMessage,
              'error',
            );
            if (this.errorTitle.length > 0) {
              document.querySelector(`.question${this.errorTitle[0].id}`).scrollIntoView({
                behavior: 'smooth',
                block: 'center',
              });
            } else if (this.errorSelectbox.length > 0 && !this.isQuestionPage) {
              document.querySelector(`.question${this.errorSelectbox[0].id}`).scrollIntoView({
                behavior: 'smooth',
                block: 'center',
              });
            }
            return false;
          }
          if (this.interview.questions.length > 20) {
            showNotification(
              this.resource['label.Error'],
              this.resource['hrvenue.InterviewEdit.InterviewMaxQuestionMessage'],
              'error',
            );
            return false;
          }
        } else if (!this.isQuestionPage && this.tabIndex === 2 && this.interview.type === 1) {
          if (this.interview.selectedLanguages?.length === 0 && this.interview.isCheckedLanguageCheckBox) {
            showNotification(
              this.resource['label.Error'],
              this.resource['hrvenue.InterviewEdit.PleaseSelectLanguageMessage'],
              'error',
            );
            this.interview.isCheckedLanguageDropdownError = true;
            return false;
          }
          const totalCriteria = this.interview.selectedLanguages?.length + this.interview.selectedCriteria?.length;
          if (totalCriteria > 7) {
            showNotification(
              this.resource['label.Error'],
              this.resource['hrvenue.evaluationCriteriaMaxError'],
              'error',
            );
            return false;
          }
        }
        this.setToclist();
        dataLayer.push({
          event: 'ga4_event',
          page_type: 'interview-create',
          site_type: 'interview',
          event_name: 'interview_form',
          event_parameters: {
            label: 'continue',
            step: this.tabIndex,
            option: this.interview.type === 3 ? 'person-interview-click' : 'video-interview-click',
            ats_integration: this.interview.isAtsIntegrationsEnabled ? 'yes' : 'not-selected',
          },
        });
        this.$router
          .replace({
            query: {
              ...this.$route.query,
            },
          })
          .catch(() => {});
      } else if (actionType === 'back' || actionType === 'upgrade') {
        this.setToclist(-1);
        dataLayer.push({
          event: 'ga4_event',
          page_type: 'interview-create',
          site_type: 'interview',
          event_name: 'interview_form',
          event_parameters: {
            label: 'back',
            step: this.tabIndex,
            option: this.interview.type === 3 ? 'person-interview-click' : 'video-interview-click',
            ats_integration: this.interview.isAtsIntegrationsEnabled ? 'yes' : 'not-selected',
          },
        });
        this.$router
          .replace({
            query: {
              ...this.$route.query,
            },
          })
          .catch(() => {});
      } else {
        this.submitInterview();
      }
    },
    updateInput(val, type) {
      if (type === 'name') {
        this.interview.name = val;
      } else {
        this.interview.title = val;
      }
    },
    validateQuestions() {
      if (this.interview.questions.length < 1) {
        return this.resource['hrvenue.InterviewEdit.PleaseAddQuestionMessage'];
      }

      this.interview.questions = this.interview.questions.map((item) => {
        !item.thinkTime ? item.isThinkTimeEmpty = true : item.isThinkTimeEmpty = false;
        !item.timeLimit ? item.isTimeLimitEmpty = true : item.isTimeLimitEmpty = false;
        return item;
      });

      this.interview.questions.filter((item) => {
        if (item.isThinkTimeEmpty || item.isTimeLimitEmpty) {
          this.errorSelectbox.push(item);
        } else {
          this.errorSelectbox = this.errorSelectbox.filter((arrayItem) => arrayItem !== item);
        }
        if (item.title === null || item.title === '' || item.title === ' ' || item.title.length < 10) {
          this.errorTitle.push(item);
        } else {
          this.errorTitle = this.errorTitle.filter((arrayItem) => arrayItem !== item);
        }
        return (
          this.errorSelectbox,
          this.errorTitle
        );
      });
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.interview.questions.length; i++) {
        const question = this.interview.questions[i];
        if (!question.title || question.title.length < 10) {
          return this.resource['hrvenue.InterviewEdit.PleaseFillRequiredAreaMessage'];
        }
        if (this.interview.type === 1 && (!question.thinkTime || !question.timeLimit)) {
          return this.resource['hrvenue.InterviewEdit.PleaseFillRequiredAreaMessage'];
        }
      }

      const questions = this.interview.questions;
      const sameTitleControl = questions.some((item, index) => questions.some(
        (item2, index2) => item2.title === item.title && index !== index2,
      ));
      if (sameTitleControl) {
        return this.resource['hrvenue.createInterview.sameQuestionMessage'];
      }

      return '';
    },
    createNewQuestion() {
      this.interview.questions.push({
        id: Math.random().toString(16).slice(2), title: '', thinkTime: null, timeLimit: null,
      });
    },
    async submitInterview() {
      try {
        if (this.interview.questions.length > 20) {
          return showNotification(
            this.resource['Label.Error'],
            this.resource['hrvenue.InterviewEdit.InterviewMaxQuestionMessage'],
            'error',
          );
        }

        const validationMessage = this.validateQuestions();
        if (validationMessage) {
          return showNotification(
            this.resource['label.Error'],
            validationMessage,
            'error',
          );
        }
        this.loadingStack.detail = true;
        if (this.interview.visibilityType === 3) {
          this.interview.authorizedUsers = this.interview.authorizedUsers?.map(({ value }) => value);
        } else {
          this.interview.authorizedUsers = [];
        }
        const tempQuestion = [];
        this.interview.questions.forEach((quest, index) => {
          const { id, ...others } = quest;
          tempQuestion.push({
            ...others,
            order: index + 1,
          });
        });
        if (!this.interview.id) {
          const { created, id: interviewId } = await HrVenueService.createInterview(
            this.interview.name,
            '',
            null,
            tempQuestion,
            this.isQuestionPage ? 2 : this.interview.type,
            this.interview.visibilityType,
            this.interview.authorizedUsers,
            this.interview.position?.id || null,
            this.interview.emailLanguage?.id || null,
            this.interview.questionLanguage?.id || null,
            this.interview.jobDescription || '',
          );
          // eslint-disable-next-line no-debugger
          if (created) {
            // showNotification(
            //   this.resource['Label.Success'],
            //   this.resource['hrvenue.InterviewEdit.SuccessMessage'],
            //   'success',
            // );
            const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

            this.interview.selectedLanguages = this.interview.selectedLanguages.map((criteria) => ({
              ...criteria,
              criteriaId: '',
            }));

            this.interview.selectedCriteria = this.interview.selectedCriteria.map((criteria) => (criteria.isAiGenerated
              ? { ...criteria, criteriaId: '' }
              : criteria));

            const allCriterias = this.interview.selectedLanguages.concat(this.interview.selectedCriteria);
            if (allCriterias.length > 0) {
              await HrVenueService.addOrUpdateInterviewCriteria(interviewId, null, allCriterias);
            }
            this.layout.isSubmit = true;
            this.isQuestionPage
              ? this.$router.push({
                name: 'QuestionGeneratorList',
                params: {
                  lang,
                },
              })
              : this.$router.push({
                name: 'InterviewDetailView',
                params: {
                  interviewId,
                  showSelectionScreen: true,
                  lang,
                },
              });
          }
        } else {
          const { updated } = await HrVenueService.updateInterview(
            this.interview.id,
            this.interview.name,
            '',
            this.interview.expireDate,
            JSON.stringify(this.oldQuestions) !== JSON.stringify(this.interview.questions),
            true,
            tempQuestion,
            this.interview.isSent,
            this.isQuestionPage ? 2 : this.interview.type,
            this.interview.visibilityType,
            this.interview.authorizedUsers,
            this.interview.position?.id || null,
            this.interview.emailLanguage?.id || null,
            this.interview.questionLanguage?.id || null,
            this.interview.jobDescription || '',
          );
          if (updated) {
            this.interview.selectedLanguages = this.interview.selectedLanguages.map((criteria) => ({
              ...criteria,
              criteriaId: '',
            }));

            this.interview.selectedCriteria = this.interview.selectedCriteria.map((criteria) => (criteria.isAiGenerated
              ? { ...criteria, criteriaId: '' }
              : criteria));

            const allCriterias = this.interview.selectedLanguages.concat(this.interview.selectedCriteria);
            await HrVenueService.addOrUpdateInterviewCriteria(this.interview.id, null, allCriterias);
            if (this.interview.isSent) {
              showNotification(
                this.resource['Label.Warning'],
                this.resource['interviewCreateEdit.SentInterviewWarning'],
                'warning',
              );
            } else {
              showNotification(
                this.resource['Label.Success'],
                this.resource['hrvenue.InterviewEdit.SuccessMessage'],
                'success',
              );
            }
            this.layout.isSubmit = true;
            const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

            this.isQuestionPage
              ? this.$router.push({
                name: 'QuestionGeneratorList',
                params: {
                  lang,
                },
              })
              : this.$router.push({
                name: 'HrVenueView',
                params: {
                  lang,
                },
              });
          }
        }
        dataLayer.push({
          event: 'ga4_event',
          event_name: this.isQuestionPage ? 'question_list_saved' : 'create_interview_saved',
          page_type: this.isQuestionPage ? 'question-list-create' : 'interview-create',
          site_type: 'interview',
        });
      } catch (error) {
        showNotification(
          this.resource['Label.Error'],
          this.resource['hrvenue.InterviewEdit.ErrorMessage'],
          'error',
        );
      }
      this.layout.isSubmit = false;
      this.loadingStack = { detail: false };
    },
    onDeleteQuestion(order, question) {
      if (question.title) {
        this.interview.questions = this.interview.questions.filter((quest) => quest.id !== question.id);
        this.tempBankQuestion = this.tempBankQuestion.map((quest) => { if (quest.id === question.id) { quest.selected = false; } return quest; });
        this.bankQuestion.questions = this.bankQuestion.questions.map((quest) => { if (quest.id === question.id) { quest.selected = false; } return quest; });
        this.tempBankQuestionAI = this.tempBankQuestionAI.map((quest) => { if (quest.title === question.title) { quest.selected = false; } return quest; });
        this.bankQuestionAI.questions = this.bankQuestionAI.questions.map((quest) => { if (quest.title === question.title) { quest.selected = false; } return quest; });
        this.tempBankQuestionAts = this.tempBankQuestionAts.map((quest) => { if (quest.title === question.title) { quest.selected = false; } return quest; });
        this.bankQuestionAts.questions = this.bankQuestionAts.questions.map((quest) => { if (quest.title === question.title) { quest.selected = false; } return quest; });
        this.interview.questions.length === 0 && this.createNewQuestion();
      } else {
        this.interview.questions.splice(order, 1);
        this.tempBankQuestion = this.tempBankQuestion.map((quest) => { if (quest.id === question.id) { quest.selected = false; } return quest; });
        this.bankQuestion.questions = this.bankQuestion.questions.map((quest) => { if (quest.id === question.id) { quest.selected = false; } return quest; });
        this.tempBankQuestionAI = this.tempBankQuestionAI.map((quest) => { if (quest.title === question.title) { quest.selected = false; } return quest; });
        this.bankQuestionAI.questions = this.bankQuestionAI.questions.map((quest) => { if (quest.title === question.title) { quest.selected = false; } return quest; });
        this.tempBankQuestionAts = this.tempBankQuestionAts.map((quest) => { if (quest.title === question.title) { quest.selected = false; } return quest; });
        this.bankQuestionAts.questions = this.bankQuestionAts.questions.map((quest) => { if (quest.title === question.title) { quest.selected = false; } return quest; });
      }
      if (question.questionGeneratorId) {
        const hasMatchingQuestion = this.interview.questions.some((q) => q.questionGeneratorId === question.questionGeneratorId);
        if (!hasMatchingQuestion) {
          const indexToDelete = this.interview.addedQuestionList.findIndex((item) => item === question.questionGeneratorId);
          if (indexToDelete !== -1) {
            this.interview.addedQuestionList.splice(indexToDelete, 1);
          }
        }
      }
    },
  },
};
</script>

<style lang="scss">
@import '~@/style/starter.scss';
.container {
  max-width: 572px !important;
  margin-bottom: 64px;

  &:has(.type-information-container) {
    min-height: calc(100vh - 105px);
    margin-bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  &:has(.detail-information) {
    max-width: 1124px !important;

    .vertical-stepper {
      max-width: 532px !important;
      margin: 0 auto;
    }
  }
}

.job-create-view {
  padding: 0 !important;

  .slide-enter-active {
    transition: all 0.3s ease;
  }

  .slide-leave-active {
    display: none;
  }

  .slide-enter,
  .slide-leave-to {
    opacity: 0;
  }
}

.interview-action-bar {
  position: fixed;
  bottom: 0;
  width: calc(100% - 250px);
  left: 250px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  z-index: 2;
  background: #fff;
  padding: 12px 16px;
  border-top: 1px solid var(--Stroke-Colors-Primary-Gray-Stroke, #E5E5E5);

  div {
    &:first-child {
      padding: 0 !important;
      display: flex;
      justify-content: flex-end;

      @media only screen and (max-width: map-get($grid-breakpoints, 'md')) {
        width: 100%;
      }
    }
  }

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 40px;
  }

  @media only screen and (max-width: map-get($grid-breakpoints, 'md')) {
    width: 100vw;
    left: 0;

    div {
      &:first-child {
        justify-content: space-between;
      }
    }

    .single-button {
      width: 100% !important;
    }

    .first-button {
      width: 20% !important;
    }

    .second-button {
      width: 79% !important;
    }
  }
}
</style>
